import * as React from "react";
import { cn } from "../../lib/utils";
import {
  FormControl,
  FormLabel,
  FormDescription,
  FormMessage,
  FormItem,
  FormItemProps,
} from "../form";

const Textarea = React.forwardRef<
  HTMLTextAreaElement,
  React.ComponentProps<"textarea">
>(({ className, ...props }, ref) => {
  return (
    <textarea
      className={cn(
        "flex min-h-[80px] w-full px-3 py-2 text-base md:text-sm",
        "bg-background placeholder:text-muted-foreground",
        "rounded-lg border border-input",
        "disabled:cursor-not-allowed disabled:opacity-50 disabled:bg-muted",
        "ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring",
        className
      )}
      ref={ref}
      {...props}
    />
  );
});
Textarea.displayName = "Textarea";

const FormTextarea = React.forwardRef<
  HTMLTextAreaElement,
  FormItemProps<typeof Textarea, string>
>(({ className, label, description, onChange, ...props }, ref) => {
  const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    onChange?.(e.target.value);
  };

  return (
    <FormItem>
      <FormLabel>{label}</FormLabel>
      <FormControl>
        <Textarea
          className={className}
          {...props}
          ref={ref}
          onChange={handleChange}
        />
      </FormControl>
      {description && <FormDescription>{description}</FormDescription>}
      <FormMessage />
    </FormItem>
  );
});

FormTextarea.displayName = "FormTextarea";

export { Textarea, FormTextarea };
